import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import { ConfigProvider } from 'antd';
import AuthProvider from 'contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './i18n';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';

const theme = createTheme({
  typography: {
    fontFamily: '"Noto Sans KR", "Meiryo UI", sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    body1: {
      lineHeight: 'normal'
    },
    body2: {
      lineHeight: 'normal'
    },
    h1: {
      lineHeight: 'normal'
    },
    h2: {
      lineHeight: 'normal'
    },
    h3: {
      lineHeight: 'normal'
    },
    h4: {
      lineHeight: 'normal'
    },
    h5: {
      lineHeight: 'normal'
    },
    h6: {
      lineHeight: 'normal'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
      body {
        font-family: 'Noto Sans KR', sans-serif; /* 기본 폰트 */
      }

      /* 일본어의 경우 Meiryo UI 폰트 적용 */
      [lang="ja"] body {
        font-family: Meiryo UI, sans-serif;
      }
    `
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          },
          '&.Mui-focused': {
            boxShadow: 'none'
          }
        }
      }
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localStorage.getItem('language') || 'ko'}>
      <AuthProvider>
        <BrowserRouter>
          <CookiesProvider>
            <ConfigProvider>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
              </ThemeProvider>
            </ConfigProvider>
          </CookiesProvider>
        </BrowserRouter>
      </AuthProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
